(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["flourish-gingerbread-landing"] && !Shopify.designMode) return;
  try {
    
(function () {
  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function pad(value) {
    var text = String(value);
    return text.length < 2 ? '0' + text : text;
  }

  function ensureKlaviyo(companyId) {
    if (!companyId || window.klaviyo) return;
    if (document.querySelector('script[src*="static.klaviyo.com/onsite/js/klaviyo.js"]')) return;
    var script = document.createElement('script');
    script.async = true;
    script.src = 'https://static.klaviyo.com/onsite/js/klaviyo.js?company_id=' + encodeURIComponent(companyId);
    document.head.appendChild(script);
  }

  function initLanding(root) {
    if (!root || root.dataset.gbReady === 'true') return;
    root.dataset.gbReady = 'true';

    ensureKlaviyo(root.dataset.klaviyoCompany);

    var signup = root.querySelector('[data-gb-signup]');
    var formPanel = root.querySelector('[data-gb-form]');
    var livePanel = root.querySelector('[data-gb-live]');
    var count = root.querySelector('[data-gb-count]');
    var sticky = root.querySelector('[data-gb-sticky]');
    var success = root.querySelector('[data-gb-success]');
    var launch = Date.parse(root.dataset.launch || '');
    var liveReady = root.dataset.liveReady === 'true' && root.dataset.liveUrl;
    var subscribed = false;
    var mode = 'signup';

    function setLive() {
      mode = 'live';
      if (count) count.hidden = true;
      if (formPanel) formPanel.hidden = true;
      if (livePanel) livePanel.hidden = false;
      root.querySelectorAll('[data-gb-jump]').forEach(function (link) {
        link.href = root.dataset.liveUrl;
        var label = link.querySelector('[data-gb-jump-label]');
        if (label) label.textContent = root.dataset.liveLabel || 'Shop Gingerbread';
      });
    }

    function renderCountdown() {
      if (!count || Number.isNaN(launch)) {
        if (count) count.hidden = !root.hasAttribute('data-gb-design');
        return;
      }
      var diff = launch - Date.now();
      if (diff <= 0) {
        count.hidden = true;
        if (liveReady) setLive();
        if (root._gbTimer) {
          window.clearInterval(root._gbTimer);
          root._gbTimer = null;
        }
        return;
      }
      count.hidden = false;
      var total = Math.floor(diff / 1000);
      var days = Math.floor(total / 86400);
      var hours = Math.floor((total % 86400) / 3600);
      var minutes = Math.floor((total % 3600) / 60);
      var seconds = total % 60;
      root.querySelector('[data-gb-dd]').textContent = pad(days);
      root.querySelector('[data-gb-hh]').textContent = pad(hours);
      root.querySelector('[data-gb-mm]').textContent = pad(minutes);
      root.querySelector('[data-gb-ss]').textContent = pad(seconds);
      count.querySelector('[role="timer"]').setAttribute(
        'aria-label',
        days + ' days, ' + hours + ' hours, ' + minutes + ' minutes, ' + seconds + ' seconds'
      );
    }

    if (!Number.isNaN(launch)) {
      renderCountdown();
      root._gbTimer = window.setInterval(renderCountdown, 1000);
    } else if (count) {
      count.hidden = !root.hasAttribute('data-gb-design');
    }

    function updateSticky(isVisible) {
      if (!sticky || !signup || root.dataset.gbSubscribed === 'true') {
        if (sticky) sticky.hidden = true;
        return;
      }
      var past = signup.getBoundingClientRect().bottom < 0;
      sticky.hidden = isVisible || !past;
    }

    if (signup && 'IntersectionObserver' in window) {
      var observer = new IntersectionObserver(function (entries) {
        updateSticky(entries[0].isIntersecting);
      }, { threshold: 0.15 });
      observer.observe(signup);
      root._gbObserver = observer;
    }

    root.querySelectorAll('[data-gb-jump]').forEach(function (link) {
      link.addEventListener('click', function (event) {
        if (mode !== 'signup' || !signup) return;
        event.preventDefault();
        signup.scrollIntoView({ behavior: reduceMotion ? 'auto' : 'smooth', block: 'start' });
        signup.focus({ preventScroll: true });
      });
    });

    root.querySelectorAll('[data-gb-variant]').forEach(function (select) {
      select.addEventListener('change', function () {
        var card = select.closest('.gb-card');
        var option = select.selectedOptions[0];
        var idInput = card.querySelector('[data-gb-id]');
        var price = card.querySelector('[data-gb-price]');
        var button = card.querySelector('[data-js-product-add-to-cart]');
        var label = card.querySelector('[data-gb-add-label]');
        if (!option || !idInput) return;
        idInput.value = option.value;
        if (price) price.textContent = option.dataset.price || '';
        var soldOut = option.disabled;
        if (button) button.disabled = soldOut;
        if (label) label.textContent = soldOut ? 'Sold out' : 'Quick Add';
      });
    });

    root.querySelectorAll('product-form').forEach(function (form) {
      form.addEventListener('add-to-cart', function () {
        var status = form.closest('.gb-card').querySelector('[data-gb-status]');
        if (!status) return;
        status.textContent = 'Added to cart';
        window.setTimeout(function () {
          status.textContent = '';
        }, 4000);
      });
    });

    var quotesRoot = root.querySelector('[data-gb-quotes]');
    if (quotesRoot) {
      var quotes = quotesRoot.querySelectorAll('[data-gb-quote]');
      var dots = quotesRoot.querySelectorAll('[data-gb-dot]');
      var current = 0;
      var timer = null;
      var delay = parseInt(quotesRoot.dataset.gbInterval, 10) || 6000;

      var showQuote = function (next) {
        current = (next + quotes.length) % quotes.length;
        quotes.forEach(function (quote, i) {
          if (i === current) {
            quote.setAttribute('data-active', '');
            quote.removeAttribute('aria-hidden');
          } else {
            quote.removeAttribute('data-active');
            quote.setAttribute('aria-hidden', 'true');
          }
        });
        dots.forEach(function (dot, i) {
          if (i === current) {
            dot.setAttribute('aria-current', 'true');
          } else {
            dot.removeAttribute('aria-current');
          }
        });
      };

      var stopQuotes = function () {
        if (timer) {
          window.clearInterval(timer);
          timer = null;
        }
      };

      var startQuotes = function () {
        if (reduceMotion || quotes.length < 2 || timer) return;
        timer = window.setInterval(function () { showQuote(current + 1); }, delay);
      };

      dots.forEach(function (dot, i) {
        dot.addEventListener('click', function () {
          stopQuotes();
          showQuote(i);
          startQuotes();
        });
      });

      quotesRoot.addEventListener('mouseenter', stopQuotes);
      quotesRoot.addEventListener('mouseleave', startQuotes);
      quotesRoot.addEventListener('focusin', stopQuotes);
      quotesRoot.addEventListener('focusout', startQuotes);
      root._gbQuoteStop = stopQuotes;
      startQuotes();
    }

    var shareStatus = root.querySelector('[data-gb-share-status]');
    var shareButton = root.querySelector('[data-gb-share]');
    var copyButton = root.querySelector('[data-gb-copy]');
    var pageUrl = window.location.href;

    if (shareButton) {
      shareButton.hidden = !navigator.share;
      shareButton.addEventListener('click', function () {
        if (!navigator.share) return;
        navigator.share({ title: document.title, url: pageUrl }).catch(function () {});
      });
    }

    if (copyButton) {
      copyButton.addEventListener('click', function () {
        var done = function () {
          if (shareStatus) shareStatus.textContent = 'Link copied';
        };
        if (navigator.clipboard && navigator.clipboard.writeText) {
          navigator.clipboard.writeText(pageUrl).then(done).catch(function () {});
        }
      });
    }

    if (!window.__gbKlaviyoBound) {
      window.__gbKlaviyoBound = true;
      window.addEventListener('klaviyoForms', function (event) {
        var detail = event.detail || {};
        if (detail.type !== 'submit') return;
        document.querySelectorAll('[data-gb-landing]').forEach(function (landing) {
          if (detail.formId !== landing.dataset.formId) return;
          landing.dataset.gbSubscribed = 'true';
          var panel = landing.querySelector('[data-gb-success]');
          var bar = landing.querySelector('[data-gb-sticky]');
          if (panel) panel.hidden = false;
          if (bar) bar.hidden = true;
        });
      });
    }

    if (root.dataset.gbSubscribed === 'true' && success) {
      subscribed = true;
      success.hidden = false;
      if (sticky) sticky.hidden = true;
    }
  }

  function boot(scope) {
    var context = scope || document;
    context.querySelectorAll('[data-gb-landing]').forEach(initLanding);
  }

  document.addEventListener('shopify:section:load', function (event) {
    var root = event.target.querySelector('[data-gb-landing]');
    if (!root) return;
    if (root._gbTimer) window.clearInterval(root._gbTimer);
    if (root._gbObserver) root._gbObserver.disconnect();
    if (root._gbQuoteStop) root._gbQuoteStop();
    root.dataset.gbReady = 'false';
    initLanding(root);
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { boot(document); });
  } else {
    boot(document);
  }
})();

  } catch(e) { console.error(e); }
})();
})();
